module.exports = __webpack_public_path__ + "img/charcoal.8de02c80.png";